module.exports = __webpack_public_path__ + "static/media/uranus.9612bc41.svg";